import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateGameType from '@/modules/game/api/hooks/useMutationUpdateGameType'
import { GameQueryKeys } from '@/modules/game/keys'
import { GetGameTypeTableData } from '@/modules/game/type'
import { useQueryClient } from '@tanstack/react-query'

interface IsActiveGameTypeProps {
	row: GetGameTypeTableData
}

export function IsActiveGameType({ row }: IsActiveGameTypeProps) {
	const { mutateAsync: updateGameType } = useMutationUpdateGameType()
	const queryClient = useQueryClient()

	const handleMutate = async (value: boolean) => {
		await updateGameType({
			id: row.id,
			payload: {
				isActive: value,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [GameQueryKeys.GetGameTypeList],
		})
	}

	return (
		<SetIsActive
			defaultChecked={row.isActive}
			onMutate={handleMutate}
			errorMessage="ไม่สามารถอัพเดทสถานะได้"
		/>
	)
}
